import { Badge } from '@/components/ui/badge';
import { isStale, isUnstamped } from '../utils/staleness';

interface StalenessBadgeProps {
  rowVersion: string | null | undefined;
  currentVersion: string;
}

/**
 * Flags a stored verdict produced by an older classifier (#1481).
 *
 * Renders nothing when the row is current — the absence of a badge is the
 * "up to date" signal, so a fully current table stays quiet.
 */
export function StalenessBadge({ rowVersion, currentVersion }: StalenessBadgeProps) {
  if (!isStale(rowVersion, currentVersion)) return null;

  return (
    <Badge
      variant="outline"
      title={
        isUnstamped(rowVersion)
          ? `No classifier version recorded; current is ${currentVersion}`
          : `Classified by ${rowVersion}; current is ${currentVersion}`
      }
      className="ml-2 border-warning/30 bg-warning/10 text-warning"
    >
      Stale
    </Badge>
  );
}
